/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import _ from 'lodash';

const state = {
  filter: {
    status: 'any',
    page: 1,
    sort: 'createdAt',
  },
};

const defaultState = {
  filter: {
    status: 'any',
    page: 1,
    sort: 'createdAt',
  },
};

const getters = {};

const mutations = {
  setFilterState(state, filter) {
    const key = Object.keys(filter)[0];
    if (!filter[key]) {
      delete state.filter[key];
      state.filter = { ...state.filter, page: 1 };
    } else {
      state.filter = { ...state.filter, page: 1, ...filter };
    }
  },
  clearFilter(state) {
    Object.assign(state, _.cloneDeep(defaultState));
  },
};

const actions = {
  setFilterState({ commit }, filter) {
    commit('setFilterState', filter);
  },
  clearFilter({ commit }) {
    commit('clearFilter');
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
